@file:OptIn(InternalResourceApi::class)

package studio.oddpods.cauce.feature.sessions.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/studio.oddpods.cauce.feature.sessions.generated.resources/"

internal val Res.string.recurring_schedule_anchor_date_label: StringResource by lazy {
      StringResource("string:recurring_schedule_anchor_date_label", "recurring_schedule_anchor_date_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 64),
      ))
    }

internal val Res.string.recurring_schedule_edit_error_load: StringResource by lazy {
      StringResource("string:recurring_schedule_edit_error_load", "recurring_schedule_edit_error_load", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75, 78),
      ))
    }

internal val Res.string.recurring_schedule_edit_save: StringResource by lazy {
      StringResource("string:recurring_schedule_edit_save", "recurring_schedule_edit_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 154, 56),
      ))
    }

internal val Res.string.recurring_schedule_edit_title: StringResource by lazy {
      StringResource("string:recurring_schedule_edit_title", "recurring_schedule_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211, 69),
      ))
    }

internal val Res.string.recurring_schedule_error_fee_invalid: StringResource by lazy {
      StringResource("string:recurring_schedule_error_fee_invalid", "recurring_schedule_error_fee_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281, 76),
      ))
    }

internal val Res.string.recurring_schedule_error_interval_invalid: StringResource by lazy {
      StringResource("string:recurring_schedule_error_interval_invalid", "recurring_schedule_error_interval_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 358, 85),
      ))
    }

internal val Res.string.recurring_schedule_error_load_patients: StringResource by lazy {
      StringResource("string:recurring_schedule_error_load_patients", "recurring_schedule_error_load_patients", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 444, 82),
      ))
    }

internal val Res.string.recurring_schedule_error_patient_required: StringResource by lazy {
      StringResource("string:recurring_schedule_error_patient_required", "recurring_schedule_error_patient_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 527, 81),
      ))
    }

internal val Res.string.recurring_schedule_error_save_failed: StringResource by lazy {
      StringResource("string:recurring_schedule_error_save_failed", "recurring_schedule_error_save_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 609, 76),
      ))
    }

internal val Res.string.recurring_schedule_fee_label: StringResource by lazy {
      StringResource("string:recurring_schedule_fee_label", "recurring_schedule_fee_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 686, 56),
      ))
    }

internal val Res.string.recurring_schedule_form_title: StringResource by lazy {
      StringResource("string:recurring_schedule_form_title", "recurring_schedule_form_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 743, 77),
      ))
    }

internal val Res.string.recurring_schedule_frequency_biweekly: StringResource by lazy {
      StringResource("string:recurring_schedule_frequency_biweekly", "recurring_schedule_frequency_biweekly", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 821, 57),
      ))
    }

internal val Res.string.recurring_schedule_frequency_custom: StringResource by lazy {
      StringResource("string:recurring_schedule_frequency_custom", "recurring_schedule_frequency_custom", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 879, 63),
      ))
    }

internal val Res.string.recurring_schedule_frequency_label: StringResource by lazy {
      StringResource("string:recurring_schedule_frequency_label", "recurring_schedule_frequency_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 943, 58),
      ))
    }

internal val Res.string.recurring_schedule_frequency_monthly: StringResource by lazy {
      StringResource("string:recurring_schedule_frequency_monthly", "recurring_schedule_frequency_monthly", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1002, 56),
      ))
    }

internal val Res.string.recurring_schedule_frequency_weekly: StringResource by lazy {
      StringResource("string:recurring_schedule_frequency_weekly", "recurring_schedule_frequency_weekly", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1059, 55),
      ))
    }

internal val Res.string.recurring_schedule_interval_days_label: StringResource by lazy {
      StringResource("string:recurring_schedule_interval_days_label", "recurring_schedule_interval_days_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1115, 70),
      ))
    }

internal val Res.string.recurring_schedule_modify_and_future: StringResource by lazy {
      StringResource("string:recurring_schedule_modify_and_future", "recurring_schedule_modify_and_future", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1186, 76),
      ))
    }

internal val Res.string.recurring_schedule_modify_single: StringResource by lazy {
      StringResource("string:recurring_schedule_modify_single", "recurring_schedule_modify_single", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1263, 64),
      ))
    }

internal val Res.string.recurring_schedule_save: StringResource by lazy {
      StringResource("string:recurring_schedule_save", "recurring_schedule_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1328, 47),
      ))
    }

internal val Res.string.session_detail_amount_paid: StringResource by lazy {
      StringResource("string:session_detail_amount_paid", "session_detail_amount_paid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1376, 50),
      ))
    }

internal val Res.string.session_detail_date: StringResource by lazy {
      StringResource("string:session_detail_date", "session_detail_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1427, 35),
      ))
    }

internal val Res.string.session_detail_delete_action: StringResource by lazy {
      StringResource("string:session_detail_delete_action", "session_detail_delete_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1463, 56),
      ))
    }

internal val Res.string.session_detail_delete_cancel: StringResource by lazy {
      StringResource("string:session_detail_delete_cancel", "session_detail_delete_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1520, 48),
      ))
    }

internal val Res.string.session_detail_delete_confirm: StringResource by lazy {
      StringResource("string:session_detail_delete_confirm", "session_detail_delete_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1569, 49),
      ))
    }

internal val Res.string.session_detail_delete_message: StringResource by lazy {
      StringResource("string:session_detail_delete_message", "session_detail_delete_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1619, 153),
      ))
    }

internal val Res.string.session_detail_delete_title: StringResource by lazy {
      StringResource("string:session_detail_delete_title", "session_detail_delete_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1773, 55),
      ))
    }

internal val Res.string.session_detail_edit_action: StringResource by lazy {
      StringResource("string:session_detail_edit_action", "session_detail_edit_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1829, 54),
      ))
    }

internal val Res.string.session_detail_error_delete: StringResource by lazy {
      StringResource("string:session_detail_error_delete", "session_detail_error_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1884, 71),
      ))
    }

internal val Res.string.session_detail_error_load: StringResource by lazy {
      StringResource("string:session_detail_error_load", "session_detail_error_load", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1956, 69),
      ))
    }

internal val Res.string.session_detail_fee: StringResource by lazy {
      StringResource("string:session_detail_fee", "session_detail_fee", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2026, 34),
      ))
    }

internal val Res.string.session_detail_payment_paid: StringResource by lazy {
      StringResource("string:session_detail_payment_paid", "session_detail_payment_paid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2061, 43),
      ))
    }

internal val Res.string.session_detail_payment_partial: StringResource by lazy {
      StringResource("string:session_detail_payment_partial", "session_detail_payment_partial", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2105, 50),
      ))
    }

internal val Res.string.session_detail_payment_pending: StringResource by lazy {
      StringResource("string:session_detail_payment_pending", "session_detail_payment_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2156, 50),
      ))
    }

internal val Res.string.session_detail_payment_status: StringResource by lazy {
      StringResource("string:session_detail_payment_status", "session_detail_payment_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2207, 57),
      ))
    }

internal val Res.string.session_detail_payment_waived: StringResource by lazy {
      StringResource("string:session_detail_payment_waived", "session_detail_payment_waived", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2265, 49),
      ))
    }

internal val Res.string.session_detail_session_status: StringResource by lazy {
      StringResource("string:session_detail_session_status", "session_detail_session_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2315, 61),
      ))
    }

internal val Res.string.session_detail_status_cancelled: StringResource by lazy {
      StringResource("string:session_detail_status_cancelled", "session_detail_status_cancelled", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2377, 51),
      ))
    }

internal val Res.string.session_detail_status_confirmed: StringResource by lazy {
      StringResource("string:session_detail_status_confirmed", "session_detail_status_confirmed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2429, 55),
      ))
    }

internal val Res.string.session_detail_status_scheduled: StringResource by lazy {
      StringResource("string:session_detail_status_scheduled", "session_detail_status_scheduled", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2485, 55),
      ))
    }

internal val Res.string.session_detail_title: StringResource by lazy {
      StringResource("string:session_detail_title", "session_detail_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2541, 52),
      ))
    }

internal val Res.string.session_detail_type: StringResource by lazy {
      StringResource("string:session_detail_type", "session_detail_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2773, 35),
      ))
    }

internal val Res.string.session_detail_type_double: StringResource by lazy {
      StringResource("string:session_detail_type_double", "session_detail_type_double", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2594, 42),
      ))
    }

internal val Res.string.session_detail_type_final: StringResource by lazy {
      StringResource("string:session_detail_type_final", "session_detail_type_final", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2637, 41),
      ))
    }

internal val Res.string.session_detail_type_first: StringResource by lazy {
      StringResource("string:session_detail_type_first", "session_detail_type_first", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2679, 45),
      ))
    }

internal val Res.string.session_detail_type_regular: StringResource by lazy {
      StringResource("string:session_detail_type_regular", "session_detail_type_regular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2725, 47),
      ))
    }

internal val Res.string.sessions_date_label: StringResource by lazy {
      StringResource("string:sessions_date_label", "sessions_date_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2809, 39),
      ))
    }

internal val Res.string.sessions_edit_save: StringResource by lazy {
      StringResource("string:sessions_edit_save", "sessions_edit_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2849, 46),
      ))
    }

internal val Res.string.sessions_edit_title: StringResource by lazy {
      StringResource("string:sessions_edit_title", "sessions_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2896, 47),
      ))
    }

internal val Res.string.sessions_error_fee_invalid: StringResource by lazy {
      StringResource("string:sessions_error_fee_invalid", "sessions_error_fee_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2944, 66),
      ))
    }

internal val Res.string.sessions_error_limit_reached: StringResource by lazy {
      StringResource("string:sessions_error_limit_reached", "sessions_error_limit_reached", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3011, 104),
      ))
    }

internal val Res.string.sessions_error_load_patients: StringResource by lazy {
      StringResource("string:sessions_error_load_patients", "sessions_error_load_patients", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3116, 72),
      ))
    }

internal val Res.string.sessions_error_patient_required: StringResource by lazy {
      StringResource("string:sessions_error_patient_required", "sessions_error_patient_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3189, 71),
      ))
    }

internal val Res.string.sessions_error_save_failed: StringResource by lazy {
      StringResource("string:sessions_error_save_failed", "sessions_error_save_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3261, 74),
      ))
    }

internal val Res.string.sessions_fee_label: StringResource by lazy {
      StringResource("string:sessions_fee_label", "sessions_fee_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3336, 46),
      ))
    }

internal val Res.string.sessions_form_title: StringResource by lazy {
      StringResource("string:sessions_form_title", "sessions_form_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3383, 51),
      ))
    }

internal val Res.string.sessions_patient_label: StringResource by lazy {
      StringResource("string:sessions_patient_label", "sessions_patient_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3435, 46),
      ))
    }

internal val Res.string.sessions_pending_confirm: StringResource by lazy {
      StringResource("string:sessions_pending_confirm", "sessions_pending_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3482, 44),
      ))
    }

internal val Res.string.sessions_pending_no_ocurrio: StringResource by lazy {
      StringResource("string:sessions_pending_no_ocurrio", "sessions_pending_no_ocurrio", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3527, 51),
      ))
    }

internal val Res.string.sessions_pending_scope_prompt: StringResource by lazy {
      StringResource("string:sessions_pending_scope_prompt", "sessions_pending_scope_prompt", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3579, 81),
      ))
    }

internal val Res.string.sessions_pending_title: StringResource by lazy {
      StringResource("string:sessions_pending_title", "sessions_pending_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3661, 62),
      ))
    }

internal val Res.string.sessions_save: StringResource by lazy {
      StringResource("string:sessions_save", "sessions_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3724, 45),
      ))
    }

internal val Res.string.sessions_type_double: StringResource by lazy {
      StringResource("string:sessions_type_double", "sessions_type_double", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3770, 36),
      ))
    }

internal val Res.string.sessions_type_final: StringResource by lazy {
      StringResource("string:sessions_type_final", "sessions_type_final", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3807, 35),
      ))
    }

internal val Res.string.sessions_type_first: StringResource by lazy {
      StringResource("string:sessions_type_first", "sessions_type_first", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3843, 39),
      ))
    }

internal val Res.string.sessions_type_label: StringResource by lazy {
      StringResource("string:sessions_type_label", "sessions_type_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3883, 47),
      ))
    }

internal val Res.string.sessions_type_regular: StringResource by lazy {
      StringResource("string:sessions_type_regular", "sessions_type_regular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3931, 41),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("recurring_schedule_anchor_date_label", Res.string.recurring_schedule_anchor_date_label)
  map.put("recurring_schedule_edit_error_load", Res.string.recurring_schedule_edit_error_load)
  map.put("recurring_schedule_edit_save", Res.string.recurring_schedule_edit_save)
  map.put("recurring_schedule_edit_title", Res.string.recurring_schedule_edit_title)
  map.put("recurring_schedule_error_fee_invalid", Res.string.recurring_schedule_error_fee_invalid)
  map.put("recurring_schedule_error_interval_invalid", Res.string.recurring_schedule_error_interval_invalid)
  map.put("recurring_schedule_error_load_patients", Res.string.recurring_schedule_error_load_patients)
  map.put("recurring_schedule_error_patient_required", Res.string.recurring_schedule_error_patient_required)
  map.put("recurring_schedule_error_save_failed", Res.string.recurring_schedule_error_save_failed)
  map.put("recurring_schedule_fee_label", Res.string.recurring_schedule_fee_label)
  map.put("recurring_schedule_form_title", Res.string.recurring_schedule_form_title)
  map.put("recurring_schedule_frequency_biweekly", Res.string.recurring_schedule_frequency_biweekly)
  map.put("recurring_schedule_frequency_custom", Res.string.recurring_schedule_frequency_custom)
  map.put("recurring_schedule_frequency_label", Res.string.recurring_schedule_frequency_label)
  map.put("recurring_schedule_frequency_monthly", Res.string.recurring_schedule_frequency_monthly)
  map.put("recurring_schedule_frequency_weekly", Res.string.recurring_schedule_frequency_weekly)
  map.put("recurring_schedule_interval_days_label", Res.string.recurring_schedule_interval_days_label)
  map.put("recurring_schedule_modify_and_future", Res.string.recurring_schedule_modify_and_future)
  map.put("recurring_schedule_modify_single", Res.string.recurring_schedule_modify_single)
  map.put("recurring_schedule_save", Res.string.recurring_schedule_save)
  map.put("session_detail_amount_paid", Res.string.session_detail_amount_paid)
  map.put("session_detail_date", Res.string.session_detail_date)
  map.put("session_detail_delete_action", Res.string.session_detail_delete_action)
  map.put("session_detail_delete_cancel", Res.string.session_detail_delete_cancel)
  map.put("session_detail_delete_confirm", Res.string.session_detail_delete_confirm)
  map.put("session_detail_delete_message", Res.string.session_detail_delete_message)
  map.put("session_detail_delete_title", Res.string.session_detail_delete_title)
  map.put("session_detail_edit_action", Res.string.session_detail_edit_action)
  map.put("session_detail_error_delete", Res.string.session_detail_error_delete)
  map.put("session_detail_error_load", Res.string.session_detail_error_load)
  map.put("session_detail_fee", Res.string.session_detail_fee)
  map.put("session_detail_payment_paid", Res.string.session_detail_payment_paid)
  map.put("session_detail_payment_partial", Res.string.session_detail_payment_partial)
  map.put("session_detail_payment_pending", Res.string.session_detail_payment_pending)
  map.put("session_detail_payment_status", Res.string.session_detail_payment_status)
  map.put("session_detail_payment_waived", Res.string.session_detail_payment_waived)
  map.put("session_detail_session_status", Res.string.session_detail_session_status)
  map.put("session_detail_status_cancelled", Res.string.session_detail_status_cancelled)
  map.put("session_detail_status_confirmed", Res.string.session_detail_status_confirmed)
  map.put("session_detail_status_scheduled", Res.string.session_detail_status_scheduled)
  map.put("session_detail_title", Res.string.session_detail_title)
  map.put("session_detail_type", Res.string.session_detail_type)
  map.put("session_detail_type_double", Res.string.session_detail_type_double)
  map.put("session_detail_type_final", Res.string.session_detail_type_final)
  map.put("session_detail_type_first", Res.string.session_detail_type_first)
  map.put("session_detail_type_regular", Res.string.session_detail_type_regular)
  map.put("sessions_date_label", Res.string.sessions_date_label)
  map.put("sessions_edit_save", Res.string.sessions_edit_save)
  map.put("sessions_edit_title", Res.string.sessions_edit_title)
  map.put("sessions_error_fee_invalid", Res.string.sessions_error_fee_invalid)
  map.put("sessions_error_limit_reached", Res.string.sessions_error_limit_reached)
  map.put("sessions_error_load_patients", Res.string.sessions_error_load_patients)
  map.put("sessions_error_patient_required", Res.string.sessions_error_patient_required)
  map.put("sessions_error_save_failed", Res.string.sessions_error_save_failed)
  map.put("sessions_fee_label", Res.string.sessions_fee_label)
  map.put("sessions_form_title", Res.string.sessions_form_title)
  map.put("sessions_patient_label", Res.string.sessions_patient_label)
  map.put("sessions_pending_confirm", Res.string.sessions_pending_confirm)
  map.put("sessions_pending_no_ocurrio", Res.string.sessions_pending_no_ocurrio)
  map.put("sessions_pending_scope_prompt", Res.string.sessions_pending_scope_prompt)
  map.put("sessions_pending_title", Res.string.sessions_pending_title)
  map.put("sessions_save", Res.string.sessions_save)
  map.put("sessions_type_double", Res.string.sessions_type_double)
  map.put("sessions_type_final", Res.string.sessions_type_final)
  map.put("sessions_type_first", Res.string.sessions_type_first)
  map.put("sessions_type_label", Res.string.sessions_type_label)
  map.put("sessions_type_regular", Res.string.sessions_type_regular)
}
